module.exports = __webpack_public_path__ + "img/Security IT Summit.311e8b9b.png";